<span class="pkt-badge" [class]="'pkt-badge pkt-badge--' + variant + ' pkt-badge--' + size" [class.pill]="pill" [class.pkt-badge--bordered]="bordered">
  <span *ngIf="dot" class="pkt-badge-dot"></span>
  <span *ngIf="icon" class="material-symbols-outlined pkt-badge-icon">{{ icon }}</span>
  <ng-content></ng-content>
  <span *ngIf="label">{{ label }}</span>
  <span *ngIf="count !== null" class="pkt-badge-count">{{ count }}</span>
</span>